import VueGettext from 'vue-gettext'
import { sprintf } from 'sprintf-js'

const VueGettextExtended = {
  install (Vue, options = {}) {
    Vue.use(VueGettext, options)

    /**
     * Translate string with gettext and optional sprintf iterpolation
     * @param {String} msgid
     * @param {Object} formatting
     */
    Vue.prototype.$t = function (msgid, formatting) {
      let translatedMessage = this.$gettext(msgid)
      if (formatting) {
        translatedMessage = sprintf(translatedMessage, formatting)
      }
      return translatedMessage
    }

    /* Register filters */
    Vue.filter('sprintf', (value, ...args) => sprintf(value, ...args))
  }
}

export default VueGettextExtended
